/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CategorieDocumentDto } from '../models/categorie-document-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des catégories de documents
 */
@Injectable({
  providedIn: 'root',
})
export class CategoriesDocumentsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation categorieDocumentGetList
   */
  static readonly CategorieDocumentGetListPath = '/api/categories-documents/list';

  /**
   * Renvoie la liste des catégories de documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieDocumentGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieDocumentGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<CategorieDocumentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesDocumentsService.CategorieDocumentGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CategorieDocumentDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des catégories de documents.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieDocumentGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieDocumentGetList(params?: {
  }): Observable<Array<CategorieDocumentDto>> {

    return this.categorieDocumentGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CategorieDocumentDto>>) => r.body as Array<CategorieDocumentDto>)
    );
  }

  /**
   * Path part for operation categorieDocumentLoadList
   */
  static readonly CategorieDocumentLoadListPath = '/api/categories-documents/load-list';

  /**
   * Renvoie la liste des catégories de documents (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieDocumentLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieDocumentLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesDocumentsService.CategorieDocumentLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des catégories de documents (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieDocumentLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieDocumentLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.categorieDocumentLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation categorieDocumentGet
   */
  static readonly CategorieDocumentGetPath = '/api/categories-documents/{id}';

  /**
   * Renvoie la catégorie de documents spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieDocumentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieDocumentGet$Response(params: {

    /**
     * Identifiant de la catégorie de documents
     */
    id: number;
  }): Observable<StrictHttpResponse<CategorieDocumentDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesDocumentsService.CategorieDocumentGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategorieDocumentDto>;
      })
    );
  }

  /**
   * Renvoie la catégorie de documents spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieDocumentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieDocumentGet(params: {

    /**
     * Identifiant de la catégorie de documents
     */
    id: number;
  }): Observable<CategorieDocumentDto> {

    return this.categorieDocumentGet$Response(params).pipe(
      map((r: StrictHttpResponse<CategorieDocumentDto>) => r.body as CategorieDocumentDto)
    );
  }

  /**
   * Path part for operation categorieDocumentPut
   */
  static readonly CategorieDocumentPutPath = '/api/categories-documents/{id}';

  /**
   * Met à jour la catégorie de documents spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieDocumentPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieDocumentPut$Response(params: {

    /**
     * Identifiant de la catégorie de documents à mettre à jour
     */
    id: number;

    /**
     * Catégorie de documents
     */
    body: CategorieDocumentDto
  }): Observable<StrictHttpResponse<CategorieDocumentDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesDocumentsService.CategorieDocumentPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategorieDocumentDto>;
      })
    );
  }

  /**
   * Met à jour la catégorie de documents spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieDocumentPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieDocumentPut(params: {

    /**
     * Identifiant de la catégorie de documents à mettre à jour
     */
    id: number;

    /**
     * Catégorie de documents
     */
    body: CategorieDocumentDto
  }): Observable<CategorieDocumentDto> {

    return this.categorieDocumentPut$Response(params).pipe(
      map((r: StrictHttpResponse<CategorieDocumentDto>) => r.body as CategorieDocumentDto)
    );
  }

  /**
   * Path part for operation categorieDocumentDelete
   */
  static readonly CategorieDocumentDeletePath = '/api/categories-documents/{id}';

  /**
   * Supprime la catégorie de documents spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieDocumentDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieDocumentDelete$Response(params: {

    /**
     * Identifiant de la catégorie de documents à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesDocumentsService.CategorieDocumentDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la catégorie de documents spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieDocumentDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieDocumentDelete(params: {

    /**
     * Identifiant de la catégorie de documents à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.categorieDocumentDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation categorieDocumentPost
   */
  static readonly CategorieDocumentPostPath = '/api/categories-documents';

  /**
   * Crée la catégorie de documents spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieDocumentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieDocumentPost$Response(params: {

    /**
     * Catégorie de documents
     */
    body: CategorieDocumentDto
  }): Observable<StrictHttpResponse<CategorieDocumentDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesDocumentsService.CategorieDocumentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategorieDocumentDto>;
      })
    );
  }

  /**
   * Crée la catégorie de documents spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieDocumentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieDocumentPost(params: {

    /**
     * Catégorie de documents
     */
    body: CategorieDocumentDto
  }): Observable<CategorieDocumentDto> {

    return this.categorieDocumentPost$Response(params).pipe(
      map((r: StrictHttpResponse<CategorieDocumentDto>) => r.body as CategorieDocumentDto)
    );
  }

}
